import moment from 'moment';
import { formatExportValue } from './WatchlistTableHelpers';

class WatchListService {
  constructor() {
    this.agGridAPI = null;
    this.agGridColumnAPI = null;
  }

  init(api, columnApi) {
    this.agGridAPI = api;
    this.agGridColumnAPI = columnApi;
  }

  autoSizeColumns = () => {
    var allColumnIds = [];
    this.agGridColumnAPI.getAllColumns().forEach(function(column) {
      allColumnIds.push(column.colId);
    });
    this.agGridColumnAPI.autoSizeColumns(allColumnIds, false);
  };

  sizeColumnsToFit = () => {
    this.agGridAPI.sizeColumnsToFit();
  };

  mangeAgGridColunms = (coldId, status) => {
    this.agGridColumnAPI.setColumnsVisible([coldId], status);
  };

  getDisplayedColumnIds = () => {
    return this.agGridColumnAPI
      ?.getColumnState()
      .filter(v => !v.hide)
      .map(v => v.colId);
  };

  clearFilter = () => {
    if (this.agGridAPI) {
      this.agGridAPI.setFilterModel(null);
    }
  };

  exportWatchlist(format) {
    const exportParams = {
      fileName: `Exports-${moment().unix()}`,
      processCellCallback: formatExportValue,
    };
    switch (format) {
      case 'csv':
        this.agGridAPI.exportDataAsCsv(exportParams);
        break;
      case 'xml':
        this.agGridAPI.exportDataAsExcel({
          exportMode: 'xml',
          ...exportParams,
        });
        break;
      case 'xlsx':
        this.agGridAPI.exportDataAsExcel(exportParams);
        break;
      default:
        break;
    }
  }
}

export default new WatchListService();
